import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';

/**
 * Service to help exclude specific HTTP requests from the loading bar
 * Usage: Add headers to your HTTP requests to skip the loading bar
 */
@Injectable({
  providedIn: 'root',
})
export class LoadingExclusionService {
  /**
   * Get headers to exclude a request from the loading bar
   * @returns HttpHeaders with the exclusion header
   */
  getExclusionHeaders(): HttpHeaders {
    return new HttpHeaders({
      'X-Skip-Loading-Bar': 'true',
    });
  }

  /**
   * Add exclusion headers to existing headers
   * @param existingHeaders - Existing HttpHeaders object
   * @returns HttpHeaders with exclusion header added
   */
  addExclusionHeaders(existingHeaders?: HttpHeaders): HttpHeaders {
    if (!existingHeaders) {
      return this.getExclusionHeaders();
    }

    return existingHeaders.set('X-Skip-Loading-Bar', 'true');
  }
}
